export default function () {

    this.restart();
};
